export default {
  common: {
    search: 'Search',
    reset: 'Reset',
    deleteTip: 'Are you sure you want to delete it?',
    title: 'Message',
    confirm: 'OK',
    cancel: 'Cancel'
  },
  select: {
    loading: 'Loading',
    noMatch: 'No matching data',
    noData: 'No data',
    placeholder: 'Select '
  },
  input: {
    placeholder: 'Enter '
  },
  tableFilter: {
    expand: 'Expand',
    packUp: 'Fold'
  },
  table: {
    toolbar: {
      reset: 'Reset',
      refreshTable: 'Refresh Table',
      exportExcel: 'Export Excel',
      combinationSort: 'Combination Sort',
      columnsSetup: 'Columns Setup',
      leftFixed: 'Left Fixed',
      notFixed: 'Not Fixed',
      rightFixed: 'Right Fixed',
      default: 'Default',
      sortUp: 'Sort Up',
      sortDown: 'Sort Down',
      fixedSort: 'Fixed / Sort',
      sortDrag: 'Sort / Drag',
      dragDropSort: 'DragDrop Sort',
      confirm: 'Confirm',
      restore: 'Restore',
      colorPickerMessage: 'Please Select at least one data'
    }
  },
  apexNavigator: {
    title: 'Apex Navigator is now online',
    content: 'Apex Navigator newly launched! Start exploring from here!',
    view: 'View',
    cancel: 'Cancel'
  }
}
